/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAction, props } from '@ngrx/store';
import { AuthActionTypes } from './action-types';
import { UserInfo } from 'src/app/core/models/entites/userInfo';

export const USER_LOGIN = createAction(
  AuthActionTypes.Login,
  props<{ username: string; password: string; rememberMe: boolean }>()
);
export const USER_LOGIN_SUCCESS = createAction(
  AuthActionTypes.LoginSuccess,
  props<{ loggedUser: UserInfo }>()
);
export const USER_LOGIN_FAILED = createAction(
  AuthActionTypes.LoginFailed,
  props<{ response: any }>()
);

export const USER_REGISTRATION = createAction(
  AuthActionTypes.Register,
  props<{ registeredUser: any }>()
);
export const USER_REGISTRATION_RESULT = createAction(
  AuthActionTypes.RegisterResponse,
  props<{ response: any }>()
);
export const USER_REGISTRATION_FAILED = createAction(
  AuthActionTypes.RegisterFailed,
  props<{ response: any }>()
);

export const USER_ACCOUNT_RECOVERY = createAction(
  AuthActionTypes.Recovery,
  props<{ email: string }>()
);
export const USER_ACCOUNT_RECOVERY_SUCCESS = createAction(
  AuthActionTypes.RecoverySuccess,
  props<{ message: string }>()
);
export const USER_ACCOUNT_RECOVERY_FAILED = createAction(
  AuthActionTypes.RecoveryFailed,
  props<{ message: string }>()
);

export const RESET_AUTH_ERROR_MESSAGE = createAction(AuthActionTypes.ResetAuthErrorMessage);
export const USER_LOGOUT = createAction(AuthActionTypes.Logout);
